import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import type PluginModel from 'garaje/models/plugin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';

export type LocationOverviewVirtualFrontDeskModel = { plugins: PluginModel[] };

export default class LocationOverviewVirtualFrontDeskRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;
  @service declare state: StateService;
  @service declare store: Store;

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('visitors-vfd-beta')) {
      // feature flag not enabled - redirect to Global Overview index (and then onto somewhere else)
      void this.router.transitionTo('location-overview');
    } else if (!this.state.visitorsSubscription?.canAccessVirtualFrontDesk) {
      // subscription does not include "virtual front desk" feature - redirect to Global Overview index (and then onto somewhere else)
      // Keeping this as a separate check/block in case we want this case to redirect to an upsell page instead.
      void this.router.transitionTo('location-overview');
    } else if (this.abilities.cannot('visit virtual-front-desk')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  async model(): Promise<LocationOverviewVirtualFrontDeskModel> {
    const plugins = await this.store.query('plugin', {
      filter: {
        notification_channels: true,
      },
      page: {
        limit: 100,
      },
    });

    return { plugins: plugins.toArray() };
  }
}
